/* eslint-env Swiftype */

/**
 * Swiftype and search
 *
 * @class rlSearch
 * @memberOf jQuery.fn
 */
(function ($) {

  $.fn.rlSearch = function () {

    var searchConfig = {
      desktopSearch: $('#DesktopSearch'),
      mobileSearch: $('#MobileSearch'),
      engineKey: $('#DesktopSearch').data('engine-key'),
      numResultsPerPage: 20,
      sortFields: {
        field: undefined,
        direction: undefined
      }
    };

    // Sets placeholder copy based on whether desktop or mobile input
    var applyPlaceholder = function () {
      var desktopPlaceholder = searchConfig.desktopSearch.data('placeholder-desktop'),
          mobilePlaceholder = searchConfig.mobileSearch.data('placeholder-mobile');

      searchConfig.desktopSearch.attr('placeholder', desktopPlaceholder);
      searchConfig.mobileSearch.attr('placeholder', mobilePlaceholder);
    };

    applyPlaceholder();

    var reloadResults = function () {
        $(window).hashchange();
        //run accessibiltiy function on reload
        accessibilityfunction();
    };

    var readSortField = function () {
      return {
        page: searchConfig.sortFields.field
      };
    };

    var readSortDirection = function () {
      return {
        page: searchConfig.sortFields.direction
      };
    };

    $('.sort').on('click', function (e) {

      e.preventDefault();
      // Visually change the selected sorting order
      $('.sort').removeClass('active');
      $(this).addClass('active');

      // Update sorting settings
      searchConfig.sortFields.field = $(this).data('field');
      searchConfig.sortFields.direction = $(this).data('direction');

      reloadResults();
    });

    var fillSearchTermFields = function(searchTerm) {
      searchConfig.desktopSearch.val(searchTerm);
      searchConfig.mobileSearch.val(searchTerm);
      $("#spanSearchTerm").text(searchTerm);
    }

    // Custom Render Function
    var renderRoyalLondonResults = function (document_type, item) {

      // title and description fields first have to check if highlight is available
      // if not available they show non highlighted content
      // description has an additional check on whether it's undefined or not

      var title;
      if (item['teaser_title'] !== undefined) {
        title = (item['highlight']['teaser_title'] !== undefined) ? item['highlight']['teaser_title'] : item['teaser_title'];
      } else {
        title = (item['highlight']['title'] !== undefined) ? item['highlight']['title'] : item['title'];
      }

      var description = ( item['highlight']['st-description'] === undefined )
                ? ( item['st-description'] === undefined )
                    ? ''
                    : item['st-description']
                : item['highlight']['st-description'],
          link = item['url'],
          out = ' \
            <div tabindex="0" class="search-result"> \
              <div class="search-result__inner"> \
                <h2 class="search-result__title">' + title + '</h2> \
                <div class="search-result__content-container"> \
                  <div class="search-result__content"> \
                    <p class="search-result__description">' + description + '</p> \
                  </div> \
                  <div tabindex="-1" class="search-result__content-cta"> \
                    <a tabindex="-1" class="sr-only hidden-btn st-search-result-link search-result__link cta" href="' + link + '" aria-label="Visit page ' + $('<div>' + title + '</div>').text() + '" > \
                      Visit page \
                    </a> \
                  </div> \
                </div> \
              </div> \
            </div>';

      return out;
    };

    //scroll to top to on paging
    var bindScrollToTop = function () {
      $(".st-page a").on("click",
        function (e) {
          $('html, body').animate({
            scrollTop: $("#search-page-container").offset().top
          }, 500);
        });
    }
    bindScrollToTop();

    var RoyalRenderPaginationForType = function (type, currentPage, totalPages) {
        var pages = '<div class="st-page">',
        previousPage, nextPage;

        if (currentPage != 1) {
            previousPage = currentPage - 1;
            pages = pages + '<a href="#" class="st-prev" data-hash="true" data-page="' + previousPage + '"><span aria-hidden="true" class="arrow">&lt;</span><span class="type">&nbsp;previous</span></a>';
        }

        if (totalPages > 1) {
            pages = pages + '<span class="paginationwrap">';
            for (i = 1; i < totalPages + 1; i++) {
                pages = pages + '<a href="#" class="st-pagenum" data-hash="true" data-page="' + i + '">' + i + '</a>';
            }
            pages = pages + '</span>';
        }

        if (currentPage < totalPages) {
            nextPage = currentPage + 1;
            pages = pages + '<a href="#" class="st-next" data-hash="true" data-page="' + nextPage + '"><span class="type">next&nbsp;</span><span aria-hidden="true" class="arrow">&gt;</span></a>';
        }

        pages += '</div>';
        return pages;
    };

    // Custom Post Render Function
    var postRenderRoyalLondonSearch = function (data) {
      var totalResultCount = 0,
          spellingSuggestion = null,
          paginationInfo = $('#pagination-head');

      if (data['info']) {
        $.each(data['info'], function (index, value) {

          totalResultCount += value['total_result_count'];

          if (value['spelling_suggestion']) {
            spellingSuggestion = value['spelling_suggestion']['text'];
          }
        });
      }

      // Set results and page count on page
      var setPaginationInfo = function (count) {
        if (count === 0) {
          paginationInfo.html('');
          $("#st-results-container").html("<p id='st-no-results' class='st-no-results'>No results found.</p>");
        }

        if ( ( count > 0 ) && ( count < searchConfig.numResultsPerPage ) ) {
          paginationInfo.html('<p class="pagination-info">You have ' + totalResultCount + ' results</p>');
        }

        if ( count > searchConfig.numResultsPerPage ) {
          paginationInfo.html('<p class="pagination-info">You have ' + totalResultCount + ' results - Page ' + data['info'].page.current_page + ' of ' + data['info'].page.num_pages + '</p>');
        }

        //BOTTOM OF PAGE PAGINATION
        var currentpaginationnumber = data['info'].page.current_page,
        totalnumberpagination = data['info'].page.num_pages,
        currentpaginationalink = $('a.st-pagenum[data-page=' + currentpaginationnumber + ']');

        function setpaginationnumbers(nextorback) {
            currentpaginationalink.addClass('st-currentpage').addClass('show');
            pagenumberlinkcount = $('.st-currentpage').attr('data-page');

            setfourprev();
            setfournext();

            if (pagenumberlinkcount <= 4) {
                setanotherfournext();
            }
            else if (pagenumberlinkcount >= totalnumberpagination - 4) {
                setanotherfourprev();  
            }

            function setfourprev() {
                $('.paginationwrap .st-currentpage').prev().addClass('show prev mob').prev().addClass('show prev mob').prev().addClass('show prev').prev().addClass('show prev last');
            }
            function setfournext() {
                $('.paginationwrap .st-currentpage').next().addClass('show next mob').next().addClass('show next mob').next().addClass('show next').next().addClass('show next last');
            }
            function setanotherfournext() {
                $('.paginationwrap .show.last').next().addClass('show next').next().addClass('show next').next().addClass('show next').next().addClass('show next');
            }
            function setanotherfourprev() {
                $('.paginationwrap .show.last').prev().addClass('show prev').prev().addClass('show prev').prev().addClass('show prev').prev().addClass('show prev');
            }


            //clean up number of paginated results
            $('.st-pagenum.show').wrapAll('<span></span>');
            paginationshowing = $('.paginationwrap .st-pagenum.show').length
            if (currentpaginationnumber <= 4 && paginationshowing > 9) {
                if (paginationshowing == 12) {
                    $('.next.st-pagenum.show:nth-child(10), .next.st-pagenum.show:nth-child(11), .next.st-pagenum.show:nth-child(12)').removeClass('show');
                }
                else if (paginationshowing == 11) {
                    $('.next.st-pagenum.show:nth-child(10), .next.st-pagenum.show:nth-child(11)').removeClass('show');
                }
                else if (paginationshowing == 10) {
                    $('.next.st-pagenum.show:nth-child(10)').removeClass('show');
                }
            }
            if (currentpaginationnumber >= totalnumberpagination - 4 && paginationshowing > 9) {
                if (paginationshowing == 13) {
                    $('.st-pagenum.show.prev:first-of-type, .st-pagenum.show.prev:nth-child(2), .st-pagenum.show.prev:nth-child(3), .st-pagenum.show.prev:nth-child(4)').removeClass('show');
                }
                else if (paginationshowing == 12) {
                    $('.st-pagenum.show.prev:first-of-type, .st-pagenum.show.prev:nth-child(2), .st-pagenum.show.prev:nth-child(3)').removeClass('show');
                }
                else if (paginationshowing == 11) {
                    $('.st-pagenum.show.prev:first-of-type, .st-pagenum.show.prev:nth-child(2)').removeClass('show');
                }
                else if (paginationshowing == 10) {
                    $('.st-pagenum.show.prev:first-of-type').removeClass('show');
                }
            }

            //apply additonal class to page numbers using three digits (or more)
            $(".st-pagenum.show").each(function () {
                threefigure = $(this).data('page');
                if (threefigure > 99) {
                    $(this).addClass('threefigure');
                }
            });

            //append rendered pagination in the pagination-head block
            $(".st-page").clone().appendTo("#pagination-head");

        }

        setpaginationnumbers();

      };

      setPaginationInfo(totalResultCount);

      if (spellingSuggestion !== null) {
        $("#st-results-container").append('<p class="st-spelling-suggestion"><strong>Did you mean</strong> <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</p>');
      }

      // update the search term in the other input (desktop/mobile)
      var searchTerm = data['info'].page.query;
      fillSearchTermFields(searchTerm);
      bindScrollToTop();

    };

    // Click handler for search results
    $('#st-results-container')
      .on('click keypress-enter', '.search-result', function(e) {
          var el = $(e.target),
            result = el.closest('.search-result'),
            dest = result.find('.search-result__link').attr('href');

          window.location = dest;
          e.preventDefault();
        })
      .on('keypress',
        '.search-result',
        function(e) {
          if (e.keyCode === 32 || e.keyCode === 13) {
            $(this).trigger('keypress-enter');
          }
        });


    // Detect current form and key count then
    // toggle relevant submit button
    $('.search-bar__input').keyup(function () {
      var _self = $(this),
        submit = $('#btnSearch--' + _self.attr('id')),
        count = _self.val().length;

      toggleSubmitButton(submit, count);
    });

    // Toggle submit button
    var toggleSubmitButton = function (el, count) {
       var toggleClass = 'search-bar__submit--hidden',
          charThreshold = 3; // Number of characters before submit button shows

      if ( count >= charThreshold ) {
         el.removeClass(toggleClass);
         $('.search-bar__input').addClass('submit-not-hidden');
      }
      if ( count < charThreshold ) {
         el.addClass(toggleClass);
         $('.search-bar__input').removeClass('submit-not-hidden');
      }
    }

    // MOBILE ONLY - Trigger closing of menu on submit
    $('#btnSearch--MobileSearch').on('click', function () {
      var burgerMenu = $('#burger-menu');

      setTimeout(function(){
        burgerMenu.trigger('click');
      }, 700 );

    });

    //see if the search button needs to be shown on page load
    $('.search-bar__input').each(function(i) {
      var _self = $(this),
        submit = $('#btnSearch--' + _self.attr('id')),
        count = _self.val().length;
      if (count) {
        toggleSubmitButton(submit, count);
      }
    });

    var getHashSearchTerm = function() {
      var hash = window.location.hash;
      var hashSearchTerm = "";
      if (hash.length) {
        var result = hash.substr(1).split('&').reduce(function(result, item) {
            var parts = item.split('=');
            result[parts[0]] = parts[1];
            return result;
          },
          {});
        hashSearchTerm = result.stq;
      }
      return hashSearchTerm;
    }

    // Truncate Text
    // @text : Text to truncate
    // @wordLimit : allowable word count
    // @after : string to append after truncated text

    var truncateText = function (text, wordLimit, after) {
      var content = text.trim();

      // Split content into words up until word limit
      content = content.split(' ').slice(0, wordLimit);

      // If after is defined append it to content
      content = content.join(' ') + (after ? after : '');

      // Return trucated vale
      return content;

    };

    // Init Desktop Search
    var isSearchPage = $("#isSearchPage").length;
    if (isSearchPage) {
      searchConfig.desktopSearch.swiftypeSearch({
        renderFunction: renderRoyalLondonResults,
        resultContainingElement: '#st-results-container',
        engineKey: searchConfig.engineKey,
        perPage: searchConfig.numResultsPerPage,
        fetchFields: {
          'page': ['title', 'teaser_title', 'url', 'st-publish-date', 'st-description']
        },        
        highlightFields: {
          'page': {
            'title': {'fallback': true},
            'teaser_title': {'fallback': true},
            'st-description': {'fallback': true}
          }
        },
        sortField: readSortField,
        sortDirection: readSortDirection,
        postRenderFunction: postRenderRoyalLondonSearch,
        renderPaginationForType: RoyalRenderPaginationForType
      });

      // Init Mobile Search
      searchConfig.mobileSearch.swiftypeSearch({
        renderFunction: renderRoyalLondonResults,
        resultContainingElement: '#st-results-container',
        engineKey: searchConfig.engineKey,
        perPage: searchConfig.numResultsPerPage,
        fetchFields: {
          'page': ['title', 'teaser_title', 'url', 'st-publish-date', 'st-description']
        },        
        highlightFields: {
          'page': {
            'title': {'fallback': true},
            'teaser_title': {'fallback': true},
            'st-description': {'fallback': true}
          }
        },
        sortField: readSortField,
        sortDirection: readSortDirection,
        postRenderFunction: postRenderRoyalLondonSearch,
        renderPaginationForType: RoyalRenderPaginationForType
      });

      // get the active search input
      var $activeSearchInput = searchConfig.desktopSearch.is(":visible") ? searchConfig.desktopSearch : searchConfig.mobileSearch;
      if ($activeSearchInput.val().length) {
        //fire the swifttype search if visible
        $activeSearchInput.closest("form").submit();
      } else {
        fillSearchTermFields(getHashSearchTerm());
      }
    }

    // Custom render for autocomplete
    var autoCompleteDesktopRender = function(document_type, item) {
      // title and description fields first have to check if highlight is available
      // if not available they show non highlighted content
      // description has an additional check on whether it's undefined or not

      var title;
      if (item['teaser_title'] !== undefined) {
        title = (item['highlight']['teaser_title'] !== undefined) ? item['highlight']['teaser_title'] : item['teaser_title'];
      } else {
        title = (item['highlight']['title'] !== undefined) ? item['highlight']['title'] : item['title'];
      }

      var description = ( item['highlight']['st-description'] === undefined )
                ? ( item['st-description'] === undefined )
                    ? ''
                    : item['st-description']
                : item['highlight']['st-description'],
          renderTitle = truncateText(title, 14, '...'),
          renderDescription = truncateText(description, 16, '...'),
          out = '<p class="title">' + renderTitle + '</p> \
                <p class="description">' + renderDescription + '</p>';

      return out
    };

    // Modify position on dropdown
    var royalLondonDropdownStylesFunction = function($this) {
      var config = $this.data('swiftype-config-autocomplete');
      var $attachEl = config.attachTo ? $(config.attachTo) : $this;
      var offset = $attachEl.offset();

      var styles = {
        'position': 'absolute',
        'z-index': 1000000001,
        'top': offset.top + $attachEl.outerHeight() + 16,
        'left': offset.left -25
      };
      if (config.setWidth) {
        styles['width'] = $attachEl.outerWidth() + 25;
      }
      return styles;
    };

    searchConfig.desktopSearch.swiftype({
      renderFunction: autoCompleteDesktopRender,      
      engineKey: searchConfig.engineKey,
      resultLimit: 6,
      dropdownStylesFunction: royalLondonDropdownStylesFunction
    });

    ///swifttype accessibility
    function getUrlVars() {
       var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key]= value;
        });
        return vars;
    }

    function accessibilityfunction() {
        $(document).on('focusin', '.search-result__content-cta .st-search-result-link', function (event) {
            var thisurl = $(this).attr('href'),
                thispage = $(this).attr('data-page'),
                thishash = $(this).attr('data-hash'),
                stp = getUrlVars()["stp"];

            //GO TO LINK WHEN USER HITS SPACEBAR (KEYCODE 32)
            window.onkeydown = function (event) {
                if (event.keyCode === 32) {

                    event.preventDefault();

                    if (thishash === 'true') {
                        var updatedUrl = location.href.replace("stp=" + stp, "stp=" + thispage);
                        window.location.href = updatedUrl;
                    }
                    else {
                        window.location.href = thisurl;
                    }
                }
            }
        });
    }

    //run accessibility function on initial load
    accessibilityfunction();

  }
}(jQuery));
